import React, { useState } from "react";
import "./styles.css";
import UserIcon from "../../assets/icons/user.png";
import { useNavigate } from "react-router-dom";
import { HttpRequest } from "../../component/service/HttpRequest";

// ฟังก์ชันสำหรับเรียก API login
async function loginUser(credentials) {
  console.log('Attempting login with credentials:', {
    username: credentials.username,
    passwordLength: credentials.password.length
  });

  try {
    // เรียก API login
    const data = await HttpRequest("/login", credentials);
    console.log('Login API Response:', data);
    return data;
  } catch (error) {
    console.error('Login API Error:', error);
    throw error;
  }
}

function LoginPage({ setToken, setLoginTimestamp, setUser }) {
  // สร้าง state สำหรับเก็บข้อมูล form
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // ฟังก์ชันจัดการการ submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Login attempt for user:', username);

    try {
      const response = await loginUser({
        username,
        password,
      });

      // ตรวจสอบว่าได้รับ token หรือไม่
      if (response?.session?.sessiontoken) {
        const token = response.session.sessiontoken;
        const timestamp = new Date().getTime();
        const userData = response.user;

        // ตรวจสอบและแปลง userData เป็น object ถ้าจำเป็น
        const userObject = typeof userData === 'string' ? JSON.parse(userData) : userData;

        // บันทึกข้อมูลลง localStorage
        localStorage.setItem("sessiontoken", token);
        localStorage.setItem("loginTimestamp", timestamp.toString());
        localStorage.setItem("user", JSON.stringify(userObject));

        // อัพเดต state
        setToken(token);
        setLoginTimestamp(timestamp);
        setUser(userObject);

        console.log('Login Successful:', {
          token: token.substring(0, 10) + '...',
          timestamp,
          user: userObject
        });

        // นำทางไปยังหน้า Report
        navigate('/report');
      } else {
        throw new Error(response.message || 'เข้าสู่ระบบไม่สำเร็จ');
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(err.message || "เกิดข้อผิดพลาดในการเชื่อมต่อ");
      setUsername("");
      setPassword("");
    }
  };

  // ส่วนแสดงผล UI
  return (
    <div className="container-login">
      <div className="login-card">
       <div className="img-round"><img src={UserIcon} alt="User Icon" className="user-icon" /></div> 
        {/**<h3>Welcome back</h3> */}

        <form onSubmit={handleSubmit} className="form-input">
          <div className="input-group">
            <label>USERNAME</label>
            <input
              className="input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              autoComplete="off"
            />
          </div>
          <div className="input-group">
            <label>PASSWORD</label>
            <input
              className="input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              autoComplete="off"
            />
          </div>
          <button type="submit" className="login-btn">
            LOGIN
          </button>
        </form>
        {/* แสดงข้อความ error ถ้ามี */}
        {error && <div className="error-message">{error}</div>}
      </div>
    </div>
  );
}

export default LoginPage;